import { ArrowDownward, ArrowUpward, SortByAlpha } from "@mui/icons-material";
import { IconButton, ListItemIcon, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { useSnackbar } from "../../../core/contexts/SnackbarContext";
import { DirecaoOrdenacao } from "../../utils/ordenarPorDescricao";

interface MenuOrdenacaoProps {
    ordenar: (direcao: DirecaoOrdenacao) => void;
    titulo?: string;
    mensagem?: string;
    desabilitado?: boolean;
}

export const MenuOrdenacao = ({ ordenar, titulo = "Ordenação", mensagem, desabilitado }: MenuOrdenacaoProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const snackbar = useSnackbar();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleOrdenar = (direcao: DirecaoOrdenacao) => {
        ordenar(direcao);
        handleClose();
        snackbar(
            mensagem ?? "Ordem alfabética aplicada. Salve o produto para gravar a nova ordem.",
            { severity: "info" }
        );
    }

    return (
        <>
            <Tooltip title={titulo}>
                <IconButton color="primary" onClick={handleClick} disabled={desabilitado}>
                    <SortByAlpha />
                </IconButton>
            </Tooltip>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem disabled>
                    <Typography variant="inherit" noWrap>
                        {titulo}
                    </Typography>
                </MenuItem>
                <MenuItem onClick={() => handleOrdenar("asc")}>
                    <ListItemIcon><ArrowDownward fontSize="small" /></ListItemIcon>
                    <Typography variant="inherit" noWrap>
                        Ordem alfabética (A - Z)
                    </Typography>
                </MenuItem>
                <MenuItem onClick={() => handleOrdenar("desc")}>
                    <ListItemIcon><ArrowUpward fontSize="small" /></ListItemIcon>
                    <Typography variant="inherit" noWrap>
                        Ordem alfabética (Z - A)
                    </Typography>
                </MenuItem>
            </Menu>
        </>
    );
}
